// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo--scale-down[data-v-1897e62d]{height:35px}", ""]);
// Exports
module.exports = exports;
